export const DS_FORM_FIELD_GROUP_CLASSES = {
  Root: "ds-form-field-group",
} as const;
